import type { DriveStep } from 'driver.js'
import type { OnboardingStep, ResolvedOnboardingSteps, OnboardingTourDefinition } from './types'

const DEFAULT_SELECTOR_WAIT_TIMEOUT_MS = 3000
const SELECTOR_POLL_DELAY_MS = 100

function wait(delayMs: number): Promise<void> {
  return new Promise(function resolveAfterDelay(resolve) {
    setTimeout(resolve, delayMs)
  })
}

async function waitForSelector(selector: string, timeoutMs: number): Promise<boolean> {
  if (import.meta.server) {
    return false
  }
  const startTime = Date.now()
  while (Date.now() - startTime <= timeoutMs) {
    if (document.querySelector(selector) !== null) {
      return true
    }
    await wait(SELECTOR_POLL_DELAY_MS)
  }
  return false
}

function toDriveStep(step: OnboardingStep): DriveStep {
  const driveStep: DriveStep = {
    popover: {
      title: step.title,
      description: step.description,
      side: step.side,
      align: step.align,
    },
  }
  if (step.selector !== undefined) {
    driveStep.element = step.selector
  }
  return driveStep
}

export async function resolveTourSteps(
  tour: OnboardingTourDefinition,
  currentPath: string,
  timeoutMs = DEFAULT_SELECTOR_WAIT_TIMEOUT_MS
): Promise<ResolvedOnboardingSteps> {
  const missingSelectors: string[] = []
  for (const step of tour.steps) {
    if (step.selector === undefined) {
      continue
    }
    if (
      typeof step.requiredPathPrefix === 'string' &&
      step.requiredPathPrefix.length > 0 &&
      !currentPath.startsWith(step.requiredPathPrefix)
    ) {
      continue
    }
    if (step.openToolbox) {
      continue
    }
    const exists = await waitForSelector(step.selector, timeoutMs)
    if (!exists) {
      missingSelectors.push(step.selector)
    }
  }
  return {
    source: tour,
    steps: tour.steps.map(toDriveStep),
    missingSelectors,
  }
}
